import { Loader2 } from "lucide-react";
import { Navigate, Outlet } from "react-router";

import { useMe } from "@/lib/api";

export function AdminRoute() {
  const { data: me, isLoading } = useMe();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="text-muted h-6 w-6 animate-spin" />
      </div>
    );
  }

  if (!me) {
    return <Navigate to="/login" replace />;
  }

  if (me.role !== "admin") {
    return <Navigate to="/home" replace />;
  }

  return <Outlet context={{ me }} />;
}

export function FacilitatorRoute() {
  const { data: me, isLoading, error } = useMe();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="text-muted h-6 w-6 animate-spin" />
      </div>
    );
  }

  if (error || !me) {
    return <Navigate to="/login" replace />;
  }

  if (me.role !== "facilitator" && me.role !== "admin") {
    return <Navigate to="/program" replace />;
  }

  return <Outlet context={{ me }} />;
}
